'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPricetag = function IoPricetag(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.3 20.4c0.9 0.9 0.9 2.4 0 3.4l-12.9 13c-0.9 0.9-2.3 0.9-3.3 0.1l-0.2-0.3-16.1-16.3-0.5-0.4c-0.4-0.5-0.7-1.1-0.8-1.9v-0.1l-0.5-7.7v-0.3c0-0.9 0.3-1.9 1-2.6l3.8-3.8c0.7-0.7 1.6-1 2.5-1h0.3l7.8 0.3c0.9 0 1.7 0.3 2.3 1l0.2 0.1 16.4 16.5z m-25.5-5.4c2 0 3.7-1.7 3.7-3.7s-1.7-3.8-3.7-3.8-3.8 1.7-3.8 3.8 1.7 3.7 3.8 3.7z' })
        )
    );
};

exports.default = IoPricetag;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pricetag.js
// module id = 2420
// module chunks = 0